module.exports = __webpack_public_path__ + "static/media/visual.ec23a040.png";